import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { stringify } from 'querystring';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginAuthenticationGuard implements CanActivate {
  constructor(private router:Router){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let token = localStorage.getItem('token');
    let nameComponent = route.routeConfig.component.name;
    if(token == null && nameComponent == "PatCodeRegisterationComponent")
    {
      return true;
    }
    if(token == null &&  (nameComponent == "LoginComponent" || nameComponent == "RegisterComponent") ){
      return true;
    }
    if(token == null)
    {
      this.router.navigate(['/login'])
      return false;
    }
    else if(nameComponent == "LoginComponent" || nameComponent == "RegisterComponent" || nameComponent == "PatCodeRegisterationComponent"){
      this.router.navigate(['/history'])
    }
    return true;
  }
  
}
